/** @graphql cc **/

import gql from 'graphql-tag';

export const ContentRendererExternalQuery = gql`
	query ContentRendererExternalQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			body {
				atlas_doc_format {
					value
				}
			}
			type
			version {
				confRev
			}
			appearancePublished: properties(key: "content-appearance-published") {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
		}
	}
`;
